const SPREADSHEET_ID = "1N52BuSDULKrSeZUHJRg2UlifWeR3FyWbOxz0bfEsh90";
const GID = "1348177975";

export async function getTotalTitleCount() {
  const query = `
    SELECT COUNT(C)
  `;

  const url =
    `https://docs.google.com/spreadsheets/d/${SPREADSHEET_ID}/gviz/tq` +
    `?gid=${GID}` +
    `&headers=1` +
    `&tqx=out:json` +
    `&tq=${encodeURIComponent(query)}`;

  const response = await fetch(url);
  const text = await response.text();

  const json = JSON.parse(
    text.substring(
      text.indexOf("{"),
      text.lastIndexOf("}") + 1
    )
  );

  return Number(json.table.rows[0]?.c[0]?.v ?? 0);
}

export async function getNationalTitleCount() {
  const query = `
    SELECT A, COUNT(B)
    GROUP BY A
    ORDER BY A DESC
    LABEL A 'season', COUNT(B) 'total'
  `;

  const url =
    `https://docs.google.com/spreadsheets/d/${SPREADSHEET_ID}/gviz/tq` +
    `?gid=${GID}` +
    `&headers=1` +
    `&tqx=out:json` +
    `&tq=${encodeURIComponent(query)}`;

  const response = await fetch(url);
  const text = await response.text();

  const json = JSON.parse(
    text.substring(
      text.indexOf("{"),
      text.lastIndexOf("}") + 1
    )
  );

  return json.table.rows.reduce((result, row) => {
    const season = row.c[0]?.v;
    const count = Number(row.c[1]?.v ?? 0);

    if (season) {
      result[season] = count;
    }

    return result;
  }, {});
}

export async function getNationalTitlesBySeason(season) {
  const query = `
    SELECT B, C
    WHERE A = '${season}'
    ORDER BY B
    LABEL B 'title', C 'athlete'
  `;

  const url =
    `https://docs.google.com/spreadsheets/d/${SPREADSHEET_ID}/gviz/tq` +
    `?gid=${GID}` +
    `&headers=1` +
    `&tqx=out:json` +
    `&tq=${encodeURIComponent(query)}`;

  const response = await fetch(url);
  const text = await response.text();

  const json = JSON.parse(
    text.substring(
      text.indexOf("{"),
      text.lastIndexOf("}") + 1
    )
  );

  return json.table.rows.map(row => ({
    title: row.c[0]?.v,
    athleteName: row.c[1]?.v,
  }));
}